export default __webpack_public_path__ + "static/media/Ertiga.bf62a4c6.png";